// src/components/SignUp.js
import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const SignUp = () => {
  const [firstName, setFirstName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isSigningUp, setIsSigningUp] = useState(false);

  // New state for the checkbox
  const [wantsUpdates, setWantsUpdates] = useState(false);

  const { signUp, signIn } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from || '/profile';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSigningUp(true);

    try {
      // Pass wantsUpdates to signUp
      await signUp(email, password, firstName, wantsUpdates);
      await signIn(email, password);
      navigate(from);
    } catch (error) {
      alert(error.message);
    } finally {
      setIsSigningUp(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} style={{ marginTop: '1rem' }}>
      <h2>Sign Up</h2>

      <label htmlFor="firstName">First Name</label>
      <br />
      <input
        type="text"
        id="firstName"
        placeholder="e.g. John"
        value={firstName}
        onChange={(e) => setFirstName(e.target.value)}
        disabled={isSigningUp}
        required
      />
      <br /><br />

      <label htmlFor="email">Email</label>
      <br />
      <input
        type="email"
        id="email"
        placeholder="Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        disabled={isSigningUp}
        required
      />
      <br /><br />

      <label htmlFor="password">Password</label>
      <br />
      <input
        type="password"
        id="password"
        placeholder="Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        disabled={isSigningUp}
        required
      />
      <br /><br />

      {/* New Updates Checkbox */}
      <label>
        <input
          type="checkbox"
          checked={wantsUpdates}
          onChange={(e) => setWantsUpdates(e.target.checked)}
          disabled={isSigningUp}
        />
        Receive product updates via email
      </label>
      <br /><br />

      <button type="submit" disabled={isSigningUp}>
        {isSigningUp ? 'Signing up...' : 'Sign Up'}
      </button>
    </form>
  );
};

export default SignUp;
